import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { FieldComponent } from './field.component';
import { TimecodeStandardFieldComponent } from './timecode-standard-field.component';

@Component({
  selector: 'app-convert-dialog',
  templateUrl: './convert-dialog.component.html',
  styleUrls: ['./convert-dialog.component.scss']
})
export class ConvertDialogComponent implements OnInit {

  @ViewChild("standardField") standardField: TimecodeStandardFieldComponent;
  @ViewChild("programStartField") programStartField: FieldComponent;

  fromValue: any;
  programStart: string = '01:00:00:00';
  standard: any;
  value: any;

  get valid(): boolean { return this.standardField.valid && this.programStartField.valid }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConvertDialogComponent>) { }

  ngOnInit() {
    this.standard = this.data.standard;
    this.value = this.data.value;
    this.fromValue = this.data.value;
  }

  displayValue(value) {
    if (value != null && value.format != null && value.drop != null) {
      let format = value.format.displayed;
      let drop = value.drop.displayed;
      return format + ' ' + drop;
    } else {
      return '';
    }
  }

  onStandardChange(event) {
    this.standard = event.standard;
    this.value = event.value;
  }

  onProgramStartChange(event) {
    this.programStart = event.value;
  }

  onClose() {
    if (this.standard == null || this.value == null || this.programStart == null) { return null }
    return {
      standard: {
        drop: this.standard.drop,
        fps: this.standard.fps,
        start: this.programStart
      },
      value: this.value
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/convert-dialog.component.ts